import { render, staticRenderFns } from "./DragonFinanceLogo.vue?vue&type=template&id=4be81782&scoped=true"
import script from "./DragonFinanceLogo.vue?vue&type=script&lang=js"
export * from "./DragonFinanceLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be81782",
  null
  
)

export default component.exports